import React, { Component } from 'react';
import { connect } from 'react-redux';
import { editClient } from 'actions/clientActions';

class ClientModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.client.name,
    };
  }

  render() {
    return (
      <div className="ClientModal">
        <h2>Client properties</h2>
        <form onSubmit={this.handleSubmit}>
          <input
            name="name"
            autoComplete="off"
            type="text"
            value={this.state.name}
            onChange={(event) => this.handleInputChange(event)}
            placeholder="Name"
          />
          <input
            type="submit"
            value="Save"
            className="btn"
            disabled={!this.state.name}
          />
        </form>
      </div>
    );
  }

  handleInputChange = (event) => {
    const name = event.target.name;
    this.setState({
      [name]: event.target.value,
    });
  };

  handleSubmit = (event) => {
    this.props.editClient({
      ...this.props.client,
      name: this.state.name,
    });
    this.props.onClose();
    event.preventDefault();
  };
}

export default connect(
  (state) => ({
    client: state.client,
  }),
  { editClient }
)(ClientModal);
